/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import documentsIcon from "@/src/assets/icons/progress/icon_progressbar_vertrag_upload.svg";
import documentIcon from "@/src/assets/icons/progress/icon_progressbar_document.svg";

const progressBarSteps = [
  {
    key: "concern",
    name: "Ihr Anliegen",
    icon: documentIcon,
  },
  {
    key: "documents",
    name: "Unterlagen",
    icon: documentsIcon,
  },
];

export default progressBarSteps;
